import React, { useState } from 'react';
import SourceSelector from './SourceSelector';
import ChatInterface from './ChatInterface';
import './ChatWidget.css';

const ChatWidget = () => {
  const [selectedSource, setSelectedSource] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  const handleSourceSelect = (source) => {
    setSelectedSource(source);
    setActiveTab(source);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const resetChat = () => {
    setSelectedSource(null);
    setActiveTab(null);
  };

  return (
    <div className={`chat-widget ${selectedSource ? 'expanded' : 'compact'}`}>
      <div className="chat-container">
        <div className="chat-header">
          <h3>Intellyx Brain Chat - Ask an AI Analyst</h3>
        </div>

        <div className="chat-body">
          {!selectedSource ? (
            <SourceSelector onSourceSelect={handleSourceSelect} />
          ) : (
            <ChatInterface 
              selectedSource={selectedSource}
              activeTab={activeTab}
              onTabChange={handleTabChange}
              onReset={resetChat}               
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatWidget;